import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';


const RedirectTelegramScreen = () => {
  const [searchParams] = useSearchParams();
  const usernameFromUrl = searchParams.get('username');
  const telegramUsername = usernameFromUrl || 'GruzAppAdmin';
  
  useEffect(() => {
    window.location.href = `https://t.me/${telegramUsername}`;

    setTimeout(() => {
      window.Telegram?.WebApp?.close();
    }, 500);
  }, [telegramUsername]);

  return (
    <div className=''>
      <p>
        Если Вас не перебросило автоматически,{' '}
        <a id="phoneLink" href={`https://t.me/${telegramUsername}`}>
          нажмите здесь
        </a>.
      </p>

    </div>
  );
};

export default RedirectTelegramScreen;
